export const PurplePill = (props: { text: string }) => (
  <div className="py-.5 inline-flex items-center justify-center rounded-full bg-secondary-lighter px-1.5">
    <span className="text-[11px] font-semibold text-secondary">
      {props.text}
    </span>
  </div>
)
